'use client';

import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { cn } from '@/lib/utils'; // Assuming cn is available

interface SuggestionButtonProps {
  text: string;
  onClick: () => void;
  disabled?: boolean;
}

// Updated Suggestion Button Component
const SuggestionButtonComponent: React.FC<SuggestionButtonProps> = ({ text, onClick, disabled }) => {
  return (
    <motion.button
      onClick={onClick}
      disabled={disabled}
      // Base styles from goausbildung, adapted slightly for qogent context (e.g., using cn)
      className={cn(
          "flex items-start justify-start w-full px-4 py-2.5 text-sm text-left",
          // Update background colors for light blue theme
          "text-blue-800 dark:text-blue-200 bg-blue-100 dark:bg-blue-950/60", 
          "rounded-xl border border-blue-200/70 dark:border-blue-800/50 shadow-sm", // Adjusted border to match blue theme
          "transition-colors backdrop-blur-sm mb-2",
          // Update hover background colors
          "hover:bg-blue-200 dark:hover:bg-blue-900/70", 
          "disabled:opacity-50 disabled:cursor-not-allowed"
      )}
      whileHover={{ 
          scale: 1.02, 
          // backgroundColor: 'rgba(255, 255, 255, 0.15)' // This might conflict with dark mode, let's rely on Tailwind hover bg for now
      }}
      whileTap={{ scale: 0.98 }}
    >
      <div className="flex items-center gap-2">
        <SparklesIcon size={16} className="text-blue-600 dark:text-blue-400 shrink-0 mt-0.5" />
        <span className="line-clamp-2">{text}</span>
      </div>
    </motion.button>
  );
};

export const SuggestionButton = memo(SuggestionButtonComponent); 